export default __webpack_public_path__ + "static/media/Fauld of Bone and Horn.0190429a.jpg";